import LearningPlan from 'views/pages/LearningPlan'
import ManagerReport from 'views/pages/ManagerReport'
import Library from 'views/pages/Library'
import Report from 'views/pages/Report'
import AllCourses from 'views/pages/AllCourses'
import Compliance from 'views/pages/Compliance'
import Discussion from 'views/pages/Discussion/index'
import { useSelector } from 'react-redux'
import Development from 'views/pages/Development'
import AddDashboardWidget from 'views/pages/Widget/AddDashboardWidget'
import ChatPage from 'views/pages/Chats/ChatPage'
import Notifications from 'views/pages/Notifications'
import MaintenanceLog from 'views/pages/MaintenanceLog'
import PublicCatalog from 'views/pages/PublicCatalog'
import SuccessPayment from 'views/pages/PublicCatalog/SuccessPayment'
import Orders from 'views/pages/PublicCatalog/Orders'
import Recruitment from 'views/pages/Recruitment/Recruitment'
import JobsManagement from 'views/pages/Recruitment/JobsManagement'
import SlackChannels from 'views/pages/SlackChannels/SlackChannels'

const recruitmentChildRoutes = [
  {
    path: '/jobs',
    name: `Jobs`,
    component: Recruitment,
    layout: '',
    key: 'job-management',
    dropdown: true,
  },
  {
    path: '/job/create',
    name: `Job Create`,
    component: Recruitment,
    layout: '',
    key: 'job-create',
    dropdown: true,
  },
  {
    path: '/job/edit',
    name: `Job Edit`,
    component: Recruitment,
    layout: '',
    key: 'job-edit',
    dropdown: true,
    hide: true,
  },
  {
    path: '/job/details',
    name: `Job Details`,
    component: Recruitment,
    layout: '',
    key: 'job-details',
    dropdown: true,
    hide: true,
  },
  {
    path: '/job/application/details',
    name: `Job Application Details`,
    component: Recruitment,
    layout: '',
    key: 'job-application-details',
    dropdown: true,
    hide: true,
  },
  {
    path: '/job-application',
    name: `Job Application`,
    component: Recruitment,
    layout: '',
    key: 'job-application',
    dropdown: true,
  },
  {
    path: '/job-archived',
    name: `Job Archived`,
    component: Recruitment,
    layout: '',
    key: 'job-archived',
    dropdown: true,
  },
  {
    path: '/job-candidates',
    name: `Job Candidate`,
    component: Recruitment,
    layout: '',
    key: 'job-candidate',
    dropdown: true,
    hide: true,
  },
  {
    path: '/job-onboard',
    name: `Job On-boarding`,
    component: Recruitment,
    layout: '',
    key: 'job-onboarding',
    dropdown: true,
  },
  {
    path: '/job/ai-interview',
    name: `AI Interview`,
    component: Recruitment,
    layout: '',
    key: 'ai-interview',
    dropdown: false,
    hide: true,
  },
  {
    path: '/job-screening',
    name: `Job Screening`,
    component: Recruitment,
    layout: '',
    key: 'job-screening',
    dropdown: true,
  },
  {
    path: '/job/interview-schedule',
    name: `Interview Schedule`,
    component: Recruitment,
    layout: '',
    key: 'job-interview',
    dropdown: true,
  },
  {
    path: '/job/career',
    name: `Career`,
    component: Recruitment,
    layout: '',
    key: 'job-career',
    dropdown: true,
  },
  {
    path: '/job/system-setup',
    name: `System Setup`,
    component: Recruitment,
    layout: '',
    key: 'job-system-setup',
    dropdown: true,
  },
]

export function useRoutes() {
  const languageRedux = useSelector((state) => state.language?.language?.data)

  const language = languageRedux || {}

  const routes = [
    {
      path: '/learning-plan',
      name: `${language.general ? language.general.learning_plan : ''}`,
      icon: 'fas fa-graduation-cap text-success',
      component: LearningPlan,
      layout: '',
      key: 'learning_plan',
    },
    {
      path: '/all-courses',
      name: `${language.general ? language.general.all_courses : ''}`,
      icon: 'far fa-copy text-warning',
      component: AllCourses,
      layout: '',
      key: 'all_courses',
    },
    {
      path: '/compliance',
      name: `${language.general ? language.general.compliance : ''}`,
      icon: 'fas fa-bookmark text-info',
      component: Compliance,
      layout: '',
      key: 'compliance',
    },
    {
      path: '/development',
      name: `${
        language.generaldevelopment
          ? language.general.development
          : 'Development'
      }`,
      icon: 'fas fa-hammer text-warning',
      component: Development,
      layout: '',
      key: 'development',
    },
    {
      path: '/add-widget',
      name: `Add widget`,
      icon: 'fas fa-hammer text-warning',
      component: AddDashboardWidget,
      layout: '',
      key: 'widget',
    },
    {
      path: '/public-catalog',
      name: `Public Catalog`,
      icon: 'fas fa-book-open text-warning',
      component: PublicCatalog,
      layout: '',
      key: 'public_catalog',
    },
    {
      path: '/messages',
      name: `Chat`,
      icon: 'fas fa-hammer text-warning',
      component: ChatPage,
      layout: '',
      key: 'chat',
    },
    {
      path: '/notifications',
      name: `Notifications`,
      icon: 'fas fa-hammer text-warning',
      component: Notifications,
      layout: '',
      key: 'notifications',
    },
    {
      path: '/library',
      name: `${language.general ? language.general.my_library : ''}`,
      icon: 'fas fa-book text-primary',
      component: Library,
      layout: '',
      key: 'my_library',
    },
    {
      path: '/report',
      name: `${language.general ? language.general.my_report : ''}`,
      icon: 'fas fa-chart-line text-warning',
      component: Report,
      layout: '',
      key: 'my_report',
    },
    {
      path: '/manager-report',
      name: `${language.general ? language.general.manager_report : ''}`,
      icon: 'fas fa-chart-area text-dark',
      component: ManagerReport,
      layout: '',
      access: [1, 3, 4, 5],
      key: 'manager_report',
    },
    {
      path: '/forms',
      name: `Forms`,
      icon: 'fas fa-clipboard text-success',
      component: MaintenanceLog,
      layout: '',
      key: 'form',
    },
    {
      path: '/jobs',
      name: `Recruitment`,
      icon: 'fas fa-user-plus text-primary',
      component: Recruitment,
      layout: '',
      key: 'recruitment',
      dropdown: true,
      childRoutes: recruitmentChildRoutes,
      hideFor: [2, 3, 4, 5],
    },
    ...recruitmentChildRoutes,
    {
      path: '/payment-success',
      name: `Payment`,
      icon: 'fas fa-clipboard text-success',
      component: SuccessPayment,
      layout: '',
      key: 'payment',
    },
    {
      path: '/orders',
      name: `Order`,
      icon: 'fas fa-clipboard text-success',
      component: Orders,
      layout: '',
      key: 'order',
    },
    {
      path: '/slack-channels',
      name: `Slack Channels`,
      icon: 'fas fa-clipboard text-success',
      component: SlackChannels,
      layout: '',
      key: 'slack-channels',
    },
    {
      path: '/my-orders',
      name: `MyOrders`,
      icon: 'fas fa-clipboard text-success',
      component: Orders,
      layout: '',
      key: 'my-orders',
    },
    {
      path: '/discussions',
      name: `${language.general ? language.general.discussions : ''}`,
      icon: 'fas fa-comment text-dark',
      component: Discussion,
      layout: '',
      access: [1, 3, 4, 5],
      key: 'discussions',
    },
  ]

  return routes
}
